import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo, references } from '@apexdesigner/schema-tools';

export const processServiceProperty = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .meta({ format: 'camelCase' })
      .describe('Property name'),

    isArray: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether this is an array'),

    isInput: z
      .boolean()
      .nullable()
      .optional()
      .describe('Data the service expects'),

    isOutput: z
      .boolean()
      .nullable()
      .optional()
      .describe('Data the service produces'),

    required: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether a value is required'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Description'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Display order'),

    serviceId: z.uuid().hidden().describe('Foreign key to ProcessService'),

    typeId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to ProcessDataType'),

    service: belongsTo('ProcessService'),

    type: references('ProcessDataType'),
  })
  .describe('An input or output property on a process service.')
  .as('ProcessServiceProperty');

export { processServiceProperty as processServicePropertySchema };
